import getEstateBaseRouteName from './getEstateBaseRouteName'
import type { EstateType } from '~/types/EstateType'

export default function getEstateDetailRouteName(estateType: EstateType) {
  return `${getEstateBaseRouteName(estateType)}-slug-id`
}
